import { render, staticRenderFns } from "./TopicCreate.vue?vue&type=template&id=27659276&scoped=true"
import script from "./TopicCreate.vue?vue&type=script&lang=js"
export * from "./TopicCreate.vue?vue&type=script&lang=js"
import style0 from "./TopicCreate.vue?vue&type=style&index=0&id=27659276&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27659276",
  null
  
)

export default component.exports